/**
 * Guided tour voice narration (Listen) — desktop by default.
 *
 * Mobile: off unless REACT_APP_GUIDED_TOUR_NARRATION_MOBILE=true
 * Dev override: localStorage guidedTourNarrationMobile = "1" | "true"
 */

export function isGuidedTourNarrationEnabled(isMobileLayout) {
  if (!isMobileLayout) {
    return true;
  }
  if (process.env.REACT_APP_GUIDED_TOUR_NARRATION_MOBILE === "true") {
    return true;
  }
  try {
    const v = localStorage.getItem("guidedTourNarrationMobile");
    return v === "1" || v === "true";
  } catch {
    return false;
  }
}
